export default "__VITE_ASSET__BFwKhIed__"